
import httpClient from "@/plugins/axios";


export const uploadImage = async (image) => {
    var formData = new FormData();
    formData.append('image', image);

    const response = await httpClient.post(`/v1/upload/image/`, formData);
    return response;
}
